import { render } from "./DataPrivacyModal.vue?vue&type=template&id=649596fc"
import script from "./DataPrivacyModal.vue?vue&type=script&lang=js"
export * from "./DataPrivacyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__